// Cost per 1M tokens in cents
const MODEL_PRICING: Record<string, { input: number; output: number }> = {
  'claude-haiku-4-5-20251001': { input: 100, output: 500 },
  'claude-sonnet-4-5-20250929': { input: 300, output: 1500 },
  'claude-opus-4-6': { input: 1500, output: 7500 },
};

export function estimateCostCents(
  model: string,
  usage: { input_tokens: number; output_tokens: number }
): number {
  const price = MODEL_PRICING[model] || MODEL_PRICING['claude-haiku-4-5-20251001'];
  const inputCents = (usage.input_tokens / 1_000_000) * price.input;
  const outputCents = (usage.output_tokens / 1_000_000) * price.output;
  return Math.round((inputCents + outputCents) * 10000) / 10000; // 4 decimal places
}

export function estimateMatchingCost(
  memberCount: number,
  model: string
): { estimatedInputTokens: number; estimatedOutputTokens: number; estimatedCostCents: number } {
  // Rough estimates per matching request:
  // ~2000 tokens per member profile, ~500 tokens system prompt
  // Output: ~200 tokens per match result
  const estimatedInputTokens = memberCount * 2000 + 500;
  const estimatedOutputTokens = memberCount * 200;
  const estimatedCostCents = estimateCostCents(model, {
    input_tokens: estimatedInputTokens,
    output_tokens: estimatedOutputTokens,
  });
  return { estimatedInputTokens, estimatedOutputTokens, estimatedCostCents };
}

export function formatCents(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}

export const MODEL_OPTIONS = [
  { value: 'claude-haiku-4-5-20251001', label: 'Haiku (fastest, cheapest)' },
  { value: 'claude-sonnet-4-5-20250929', label: 'Sonnet (balanced)' },
  { value: 'claude-opus-4-6', label: 'Opus (most capable)' },
] as const;
